export class Message {
  id = "";
  name = "";
  phone = "";
  email = "";
  subject = "";
  message = "";
  createdAt = new Date();
}
